export function TextInfo({ message }: { message: string | undefined }){
  return(
    <span style={{ color: "orange", fontSize: 12 }}>{message}</span>
  )
}